const formConfig = {
  name: "employeeForgotPasswd",
  fields: {
    username: {
      id: "person-phone",
      jsonPath: "otp.mobileNumber",
      required: true,
      floatingLabelText: "Mobile Number",
      errorMessage: "CORE_COMMON_PHONENO_INVALIDMSG",
      hintText: "Enter your mobile number",
     // pattern: "^([0-9]){10}$",
     value: "",
    },
    type: {
      id: "otp-type",
      jsonPath: "otp.type",
      value: "passwordreset",
    },
    tenantId: {
      id: "employee-forgot-password-tenantId",
      jsonPath: "otp.tenantId",
      required: true,
      floatingLabelText: "ULB",
      hintText: "Select ULB",
      value:""
    },
    userType: {
      id: "user-type",
      jsonPath: "otp.userType",
      value: "EMPLOYEE",
    },
  },
  submit: {
    type: "submit",
    label: "CONTINUE",
    id: "employee-forgot-password-submit-action",
  },
  saveUrl: "/user-otp/v1/_send",
  redirectionRoute: "/user/otp",
  action: "token",
};
export default formConfig;



// WEBPACK FOOTER //
// src/config/forms/specs/employeeForgotPasswd.js